import React, { useEffect, useState } from "react";
import T from "prop-types";
import styled from "styled-components/macro";
import callApi from "commons/util/callApi";

const Box = styled.div`
  font-size: 14px;
  width: fit-content;
  border-radius: 16px;
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 0;
  gap: 8px;
  color: var(--brown-100);
  white-space: nowrap;
  margin-bottom: 12px;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 5px;

  &:before {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    animation: dotRipple 2s ease-out infinite;
  }

  &:first-of-type {
    background-color: var(--green-100);
    &:before {
      background-color: var(--green-100);
    }
  }

  &:nth-of-type(2) {
    background-color: var(--yellow-100);
    margin-left: 8px;
    &:before {
      background-color: var(--yellow-100);
    }
  }

  @keyframes dotRipple {
    0% {
      opacity: 0;
      transform: scale(1);
    }
    30% {
      opacity: 0.6;
    }
    50% {
      opacity: 0.6;
    }
    100% {
      opacity: 0;
      transform: scale(2);
    }
  }
`;

function LiveCounters({ className }) {
  const acceptedCount = 24;
  const [waitlistCount, setWaitlistCount] = useState();

  useEffect(() => {
    async function getCount() {
      try {
        const res = await callApi("waitlist/count", "get");
        setWaitlistCount(res.count);
      } catch (e) {
        console.log(e);
      }
    }

    getCount();
  }, []);

  return (
    <Box className={className}>
      {!!acceptedCount && (
        <>
          <Dot />
          <span>
            <b>{acceptedCount}</b> accepted
          </span>
        </>
      )}
      <Dot />
      <span>
        <b>{waitlistCount}</b> waiting
      </span>
    </Box>
  );
}

LiveCounters.propTypes = {
  className: T.string,
  count: T.number,
};

export default LiveCounters;
